module.exports = __webpack_public_path__ + "static/media/main_visual_mewp_200_atj_st5_manitou.52c32c7c.png";